import { isIElementAttachmentsGroup } from "@custom-types/i-elements-type-guards";
import { IElementAttachmentsGroup } from "@custom-types/i-elements-types";
import { GUID, IElement } from "@faro-lotv/ielement-types";
import {
  selectChildDepthFirst,
  selectProjectLoadingState,
  selectRootIElement,
  WorldTransformCache,
} from "@faro-lotv/project-source";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/store-helper";

/**
 * @returns The externalId value of the selected project root IElement, which is the selected project ID
 */
export const selectRootExternalId: (state: RootState) => GUID | undefined =
  createSelector(selectRootIElement, (rootIElement) => {
    return rootIElement?.externalId;
  });

/**
 * @returns True if the project loading state is `loading`, false otherwise
 */
export const selectIsProjectLoading: (state: RootState) => boolean =
  createSelector(selectProjectLoadingState, (loadingState) => {
    return loadingState === "loading";
  });

/**
 * Selector to retrieve an attachment group. Attachment group is an iElement with typeHint "Attachments"
 * which is a children of markup iElement.
 *
 * @returns The attachment group of a markup if available
 */
export function markupAttachmentGroupSelector(
  iElement: IElement
): (state: RootState) => IElementAttachmentsGroup | undefined {
  return createSelector(
    selectChildDepthFirst(iElement, isIElementAttachmentsGroup),
    (attachmentGroup) => {
      return attachmentGroup;
    }
  );
}

/** Selector to retrieve the world transform cache of all iElements available in the store */
export const worldTransformCacheSelector: (
  state: RootState
) => WorldTransformCache = createSelector(
  (state: RootState) => state.iElements,
  (iElementsState) => {
    return iElementsState.worldTransformCache;
  }
);
